"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Dropdown = require("./Dropdown.style");

var _excluded = ["children"];

var Control = function Control(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _props$selectProps = props.selectProps,
      prefixIconName = _props$selectProps.prefixIconName,
      prefixIconClick = _props$selectProps.prefixIconClick,
      label = _props$selectProps.label,
      menuIsOpen = _props$selectProps.menuIsOpen,
      helperText = _props$selectProps.helperText,
      error = _props$selectProps.error,
      required = _props$selectProps.required,
      isDisabled = _props$selectProps.isDisabled,
      size = _props$selectProps.size;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledControlWrapper, {
    menuIsOpen: menuIsOpen,
    error: error,
    isDisabled: isDisabled,
    size: size
  }, label && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledLabel, {
    menuIsOpen: menuIsOpen,
    error: error
  }, label, " ", required && '*'), /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Control, (0, _extends2["default"])({}, props, {
    className: "eui-dd-control"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: prefixIconName,
    size: 18,
    onClick: prefixIconClick,
    ml: "15px"
  }), children), helperText && ( /*#__PURE__*/_react["default"].isValidElement(helperText) ? /*#__PURE__*/_react["default"].cloneElement(helperText, {
    error: error,
    className: 'eui-helper-text'
  }) : /*#__PURE__*/_react["default"].createElement(_Dropdown.HelperText, (0, _extends2["default"])({
    error: error
  }, props, {
    className: "eui-helper-text"
  }), helperText)));
};

exports.Control = Control;
Control.propTypes = {
  selectProps: _propTypes["default"].shape({
    prefixIconClick: _propTypes["default"].func,
    prefixIconName: _propTypes["default"].string,
    label: _propTypes["default"].string,
    menuIsOpen: _propTypes["default"].bool,
    helperText: _propTypes["default"].element,
    error: _propTypes["default"].bool,
    isDisabled: _propTypes["default"].bool,
    required: _propTypes["default"].bool,
    size: _propTypes["default"].string
  }),
  children: _propTypes["default"].node
};